import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { SecondaryButton } from '../button';

const StepIndicator = ({
  data,
  active,
  size,
  customClass,
  handleClick,
  children,
  isFormEdit,
  clickableSteps
}) => {
  return (
    <div className={`${customClass} m-step-indicator ${size}`}>
      <ul
        className='
      step__form__group-indicator m-step-indicator__steps'
      >
        {data.map((item, index) => {
          const isClickable =
            Array.isArray(clickableSteps) && clickableSteps.includes(index);
          return (
            <li
              key={item.displayName}
              className={`m-step-indicator__step ${active >= index && '-active'}`}
              onClick={() => handleClick?.(index)}
              tabIndex={isClickable ? 0 : -1}
              role={isClickable ? 'button' : undefined}
              onKeyDown={
                isClickable
                  ? (e) => {
                      if (e.key === 'Enter' || e.key === ' ') handleClick?.(index);
                    }
                  : undefined
              }
              style={isClickable ? { cursor: 'pointer' } : {}}
            >
              {data.length > 1 && <div className='m-step-indicator__node'></div>}
              <span
                className={`m-step-indicator__label ${
                  active === index && 'highlight'
                }`}
              >
                {item.displayName}
              </span>
              {item.desc && (
                <span className='m-step-indicator__label text -size-s'>
                  {item.desc}
                </span>
              )}
            </li>
          );
        })}
        {isFormEdit && (
          <SecondaryButton label={i18next.t('DYNAMIC_FORM.LABEL.CREATE_GROUP')} />
        )}
      </ul>
      {children}
    </div>
  );
};

export default StepIndicator;

StepIndicator.propTypes = {
  data: PropTypes.array,
  size: PropTypes.string,
  handleClick: PropTypes.func
};

StepIndicator.defaultProps = {
  size: '',
  data: []
};
